import { render, staticRenderFns } from "./tomaticArea.vue?vue&type=template&id=67257796&"
import script from "./tomaticArea.vue?vue&type=script&lang=js&"
export * from "./tomaticArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports